import { TableHeadersType } from '../tableHeadersType';

export const CUSTOMER_SUPPLIER_HEADER: TableHeadersType[] = [
  {
    "label": "Ledger Number",
    "value": "ledger_number",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Legal Name",
    "value": "legal_name",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Trade Name",
    "value": "trade_name",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Address 1",
    "value": "address1",
    "defaultChecked": true,
    "checked": true
  },
// 
{
  "label": "Email",
  "value": "email",
  "defaultChecked": true,
  "checked": true
},
{
  "label": "Mobile",
  "value": "mobile",
  "defaultChecked": true,
  "checked": true
},
{
  "label": "Parent Ledger",
  "value": "parent_ledger",
  "defaultChecked": true,
  "checked": true
},
{
  "label": "ADDED/MODIFIED BY",
  "value": "updated_by",
  "defaultChecked": true,
  "checked": true
},


  {
    "label": "Country",
    "value": "country",
    "defaultChecked": true,
    "checked": true
  },

  {
    "label": "Status",
    "value": "status",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Type",
    "value": "type",
    "defaultChecked": true,
    "checked": true
  },
]